import React from "react";
import { useDispatch, useSelector } from "react-redux";

//const { updateData, fetchData } = actionCreators;
const UpdateButtons = ({ moduleName, updateData, fetchData }) => {
  const dispatch = useDispatch();
  const { filters, disabledUpdateButton } = useSelector((state) => state[moduleName]);

  return (
    <>
      <button
        className="submit"
        onClick={() => dispatch(updateData({ moduleName, filters }))}
        disabled={disabledUpdateButton}
      >
        Update
      </button>
      <button
        className="submit reset"
        onClick={() => dispatch(fetchData({ moduleName, reset: true }))}
      >
        Reset
      </button>
    </>
  );
};

export default UpdateButtons;
